import React, { useEffect, useState } from 'react'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import { Container, Row, Col, Card, Button, Badge, Nav } from 'react-bootstrap';
import CustomHeader from '../Components/CustomHeader/CustomHeader';
import CustomTable from '../Components/CustomTable/CustomTable';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTrainersMainMeals } from '../hooks/MainMeals';
import { fetchOrders } from '../hooks/order';
import { useNavigate } from 'react-router-dom';
import { fetchSetting, fetchSettings } from '../hooks/settings';
function StudentMeals() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(false);

  const { list: MainMealsList, Pagination: MainMealsPagination } = useSelector((state) => state.mainMeals);
  const { list: weekList } = useSelector((state) => state.week);
  const { list: orders } = useSelector((state) => state.order);
  const { list: settings } = useSelector((state) => state.settings);

  useEffect(() => {
  const checkTime = () => {
    // التأكد من وجود البيانات أولاً
    if (!settings ) return;

    const config = settings; // نفترض أن البيانات في أول عنصر من المصفوفة
const [startH, startM] = (config.next_cycle_start || "00:00")
  .split(':')
  .map(Number);

const [endH, endM] = (config.next_cycle_end || "00:00")
  .split(':')
  .map(Number);
    const now = new Date();
    // الحصول على توقيت عمان
    const omanTime = new Date(
      now.toLocaleString("en-US", { timeZone: "Asia/Muscat" })
    );

    const currentTotalMinutes = omanTime.getHours() * 60 + omanTime.getMinutes();
    const startTotalMinutes = startH * 60 + startM;
    const endTotalMinutes = endH * 60 + endM;

    let isWithinCycle = false;

    // التعامل مع حالة مرور الوقت عبر منتصف الليل (مثلاً من 6 مساءً إلى 9 صباحاً)
    if (startTotalMinutes > endTotalMinutes) {
      isWithinCycle = currentTotalMinutes >= startTotalMinutes || currentTotalMinutes < endTotalMinutes;
    } else {
      // حالة الوقت في نفس اليوم
      isWithinCycle = currentTotalMinutes >= startTotalMinutes && currentTotalMinutes < endTotalMinutes;
    }

    // تفعيل الحالة (isActive) إذا كنا داخل وقت "الدورة" أو إذا كان الحقل is_closed مفعل يدوياً
    setIsActive(config.is_closed === 1 || isWithinCycle);
  };

  checkTime();
  const interval = setInterval(checkTime, 60000); // تحديث كل دقيقة

  return () => clearInterval(interval);
}, [settings]); // سيعمل الكود فور تحميل إعدادات الـ API
console.log(isActive,"isActiveisActive");

  useEffect(() => {
  dispatch(fetchSettings())
  }, [dispatch])
  
  const today = new Date();
console.log(weekList);
const currentWeek = weekList.find(week => {
    // إنشاء نسخة من تاريخ "اليوم" وتصفير الوقت
    const dToday = new Date(today);
    dToday.setHours(0, 0, 0, 0);

    // إنشاء نسخة من تاريخ البداية وتصفير الوقت
    const start = new Date(week.start_date);
    start.setHours(0, 0, 0, 0);

    // إنشاء نسخة من تاريخ النهاية وتصفير الوقت
    const end = new Date(week.end_date);
    end.setHours(0, 0, 0, 0);

    console.log(`Checking: ${dToday} between ${start} and ${end}`);

    return dToday >= start && dToday <= end;
});

console.log(currentWeek);
//   const currentWeek = weekList.find(week => {
//     const start = new Date(week.start_date);
//     console.log(start);
    
//     const end = new Date(week.end_date);
// console.log(end);
// console.log(today);

//     return today >= start && today <= end;
//   });
console.log(currentWeek);

const days = ["sun","mon","tue","wed","thu","fri","sat"];

const tomorrow = new Date();
tomorrow.setDate(today.getDate() + 1);

const todayKey = days[today.getDay()];
const tomorrowKey = days[tomorrow.getDay()];

console.log(todayKey);     // مثلا: mon
console.log(tomorrowKey); 

  useEffect(() => {
    const checkTime = () => {
      const now = new Date();

      // Get Oman time
      const omanTime = new Date(
        now.toLocaleString("en-US", { timeZone: "Asia/Muscat" })
      );

      const hours = omanTime.getHours();
      console.log(hours);

      // شرطك:
      // من 9 مساءً (21) إلى قبل 7 صباحاً (7)
      if (hours >= 21 || hours < 7) {
        setIsActive(true);
      } else {
        setIsActive(false);
      }
    };

    checkTime();

    // تحديث كل دقيقة
    const interval = setInterval(checkTime, 60000);

    return () => clearInterval(interval);
  }, []);


  console.log(isActive); // true أو false
  const daysMap = {
    sat: "السبت",
    sun: "الأحد",
    mon: "الإثنين",
    tue: "الثلاثاء",
    wed: "الأربعاء",
    thu: "الخميس",
    fri: "الجمعة",
  };
  console.log(currentWeek, "selectedIds");

  const tableData = Object.keys(orders?.days || {})?.map((dayKey, index) => {
    const selectedIds = orders.days[dayKey];

    return {
      id: index,
      name: daysMap[dayKey],

      // كل عمود = هل الـ category موجود ولا لأ
      ...MainMealsList?.reduce((acc, meal) => {
        acc[meal.name] = selectedIds.includes(meal.id) ? "✔️" : "❌";
        return acc;
      }, {})
    };
  });
  useEffect(() => {
    dispatch(fetchTrainersMainMeals())
    dispatch(fetchOrders(currentWeek?.id))

  }, [])
  const header = [
    "اليوم",
    ...MainMealsList.filter((item) => item.parent_id==null)?.map((item) => item.name),

    ""


  ]



  const fiteration = [
    { id: 0, title: "الوجبات", options: [{ id: "01", title: "الافطار" }, { id: "02", title: "الغداء" }, { id: "03", title: "العشاء" }] },
  ]

  const body = (
    <tbody>
      {tableData?.map((item, index) => {
        console.log(item?.name);
        
const todayArabic = daysMap[todayKey];
const tommorowArabic = daysMap[tomorrowKey];

console.log(todayArabic);
        return(
        <tr key={index}>
          <td><strong>{item?.name}</strong></td>

          {MainMealsList.filter((item) => item.parent_id==null)?.map((meal) => (
            <td key={meal.id}>
              {item[meal.name]}
            </td>
          ))}
          <td><Badge bg='primary' onClick={() => {
if(todayArabic==item?.name||tommorowArabic==item?.name){
if (isActive) {
alert(`عذراً، التعديل متاح فقط من ${settings?.next_cycle_end} إلى ${settings?.next_cycle_start}`);    

}
}else{
              navigate(`/dashboard/add-meal`)

}
//             if (isActive) {
// alert(`عذراً، التعديل متاح فقط من ${settings?.next_cycle_end} إلى ${settings?.next_cycle_start}`);    
//         } else {
//               navigate(`/dashboard/add-meal`)
//             }

          }
          }>تعديل </Badge></td>
        </tr>
)})}
    </tbody>
  );
  return (
    <div>
      <AuthNavbar />
      <Container>
        <CustomHeader
          title={"قائمة الطعام"}
          subtitle={""}
          downloadData={false}
          addData={true}
          status={"meal"}
          isActive={isActive}

        />
        <Row>
          <Col md={6}>
            <div className="d-flex justify-content-between align-items-end mb-3">
              {/* السابق */}
              {/* <Button variant="outline-primary" onClick={prevWeek}>
          السابق ⟶
        </Button> */}
              {/* التاريخ */}
              <p>
                {currentWeek?.start_date.slice(0, 10)}-------{currentWeek?.end_date.slice(0, 10)}
                {/* {formatDate(startDate)} - {formatDate(endDate)} */}
              </p>
              <div></div>


            </div>
          </Col>
        </Row>
        <CustomTable
          data={tableData}
          fiteration={[]}
          currentData={''}
          allData={''}
          header={header}
          status={"meal"}
          actions={["تعديل"]}
          body={body}

        />

      </Container>
    </div>
  )
}

export default StudentMeals
